import { RotateCw } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const RetryIcon = createLucideIcon(RotateCw);
